import React from 'react';
import Contact from '../Contact';
import Layout from '../Layout';

export default () => (
  <Layout>
    <Contact />
  </Layout>
);
